import {
  get,
  find,
  isString,
  isObject,
  includes,
  omit,
  trim,
} from 'lodash';
import qs from 'qs';
import {
  SINGLE_SELECT_EMPTY_VALUE,
  isSpecialAddressField,
  isSpecialPhoneField,
} from './custom-field-types';

export function randomString(length = 8) {
  const seed = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!@#$%^&*()_+0123456789';
  const rlimit = seed.length;
  const pwdLength = Math.max(length, 8);
  let pwd = '';
  while (pwd.length < pwdLength) {
    pwd += seed[parseInt(Math.random() * rlimit, 10)];
  }
  return pwd;
}

export function truncate(str, length) {
  if (str.length <= length) return str;
  return `${str.substring(0, length)}...`;
}

export const pluralize = (singular, count, plural = null) => {
  console.warn('[DEPRECATED] lib/functions `pluralize`. Use <FormattedMessage /> instead.');
  if (count === 1) return singular;
  return plural || `${singular}s`;
};

export function getURLParams() {
  const queryString = window.location.search.substr(1, window.location.search.length);
  return qs.parse(queryString);
}

export function getParameterByName(name) {
  return getURLParams()[name];
}

export const buildConsumerFieldValues = (values, schemas) => {
  const consumerFieldValues = [];
  const billingAddressConsumerFieldSchema = find(schemas, { name: 'billing_address' });
  const slotValues = removeBillingAddressFromMemberFields(values);

  slotValues.forEach((slot, index) => {
    Object.keys(slot).forEach((fieldName) => {
      let value = parseConsumerFieldValue(slot, fieldName);
      const consumerField = find(schemas, schema => schema.name === fieldName);
      if (isSpecialPhoneField(consumerField)) {
        value = value.selected === 'new' ? value.phone : value.selected;
        if (!value) return;
      } else if (isSpecialAddressField(consumerField)) {
        if (value.selected === 'new') {
          value = omit(value, 'selected');
        } else if (isString(value.selected)) {
          value = JSON.parse(value.selected)
        }
      }

      const fieldValue = {
        slot: index + 1,
        schemaId: getConsumerFieldSchemaId(fieldName, schemas),
        value: value,
      };

      consumerFieldValues.push(fieldValue);
    });
  });

  if (billingAddressConsumerFieldSchema && values[billingAddressConsumerFieldSchema.name]) {
    consumerFieldValues.push(buildBillingAddressConsumerFieldValue(values, billingAddressConsumerFieldSchema));
  }

  return consumerFieldValues;
}

export const buildDesktopConsumerFieldValues = (values, schemas) => {
  const consumerFieldValues = [];
  const billingAddressConsumerFieldSchema = find(schemas, { name: 'billing_address' });
  const slotValues = removeBillingAddressFromMemberFields(values);

  slotValues.forEach((slot, index) => {
    Object.keys(slot).forEach((fieldName) => {
      const value = parseConsumerFieldValue(slot, fieldName);
      const fieldValue = {
        slot: index + 1,
        schemaId: getConsumerFieldSchemaId(fieldName, schemas),
        value,
      };

      consumerFieldValues.push(fieldValue);
    });
  });

  if (billingAddressConsumerFieldSchema && values[billingAddressConsumerFieldSchema.name]) {
    consumerFieldValues.push(buildBillingAddressConsumerFieldValue(values, billingAddressConsumerFieldSchema));
  }

  return consumerFieldValues;
}

const removeBillingAddressFromMemberFields = (values) => {
  return get(values, 'memberFields.slots', []).map(value => omit(value, 'billing_address'));
}

const parseConsumerFieldValue = (slot, fieldName) => {
  let value;
  try {
    value = isString(slot[fieldName]) ? JSON.parse(slot[fieldName]) : slot[fieldName];

    if (!isObject(value)) {
      value = slot[fieldName];
    }
  } catch (e) {
    value = slot[fieldName];
  }

  if (value === 'null' || trim(value) === "" || value === SINGLE_SELECT_EMPTY_VALUE) {
    value = null
  }

  return value;
}

const buildBillingAddressConsumerFieldValue = (values, schema) => {
  let value = values[schema.name];

  if (value === 'null' || trim(value) === "") {
    value = null
  }

  if (isString(value)) {
    value = JSON.parse(value);
  }

  // This is for mobile, when desktop is componetized it will still work for both.
  if (value.selected && value.selected !== 'new') {
    value = JSON.parse(value.selected);
  }

  // Need to remove the omit statemment, exclusive for desktop.
  return {
    schemaId: schema.id,
    slot: null,
    value: omit(value, 'selected'),
  };
}

export const getConsumerFieldSchemaId = (fieldName, schemas) => {
  const schema = find(schemas, schema => schema.name === fieldName);
  return schema.id;
}

export const buildSpecialConsumerFieldInitialValues = (schemas) => {
  const types = ['shipping_address', 'billing_address', 'phone_number'];
  const result = {};
  schemas.forEach((schema) => {
    if (schema.options && schema.options.length) {
      if (includes(types, schema.name)) {
        if (isObject(schema.options[0].value)) {
          result[schema.name] = JSON.stringify(get(schema, 'options[0].value', null));
        } else {
          result[schema.name] = get(schema, 'options[0].value', null);
        }

      }
    }
  });

  return result;
}



// WEBPACK FOOTER //
// ./src/lib/functions.js